import { useEffect, useState } from 'react';
import type { Category } from '../types/Category';
import { getCategories } from '../api/categories';

let cache: Category[] | null = null;
let inflight: Promise<Category[]> | null = null;

function load(): Promise<Category[]> {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = getCategories()
    .then((data) => { cache = data; inflight = null; return data; })
    .catch((err: unknown) => { inflight = null; throw err; });
  return inflight;
}

export function clearCategoriesCache(): void { cache = null; inflight = null; }

interface Result { data: Category[] | null; loading: boolean; error: string | null; }

export function useCategories(): Result {
  const [state, setState] = useState<Result>(() =>
    cache ? { data: cache, loading: false, error: null } : { data: null, loading: true, error: null });
  useEffect(() => {
    if (cache) { setState((prev) => (prev.data === cache ? prev : { data: cache, loading: false, error: null })); return; }
    let cancelled = false;
    load()
      .then((data) => { if (!cancelled) setState({ data, loading: false, error: null }); })
      .catch((err: unknown) => { if (!cancelled) setState({ data: null, loading: false, error: err instanceof Error ? err.message : String(err) }); });
    return () => { cancelled = true; };
  }, []);
  return state;
}
